import { render, staticRenderFns } from "./ReviewList.vue?vue&type=template&id=5635d5dc&"
import script from "./ReviewList.vue?vue&type=script&lang=ts&"
export * from "./ReviewList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports